import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ListPage } from 'src/app/shared/helpers/list-page.class';
import { IGqlBaseOptions } from 'src/app/shared/modules/graphql/interfaces/base.interfaces';
import { GqlCertificationAgencyCommentService } from '../../../modules/graphql/services';
import {
  IApiAddCertificationAgencyCommentInput,
  IApiCertificationAgencyCommentConnection,
  IApiCertificationAgencyCommentFilter
} from 'src/app/shared/modules/graphql/types/types';

@Injectable()
export class CertificationAgencyCommentService {

  constructor(
    private gqlCertificationAgencyCommentService: GqlCertificationAgencyCommentService
  ) { }

  public get(filters?: IApiCertificationAgencyCommentFilter[], options?: IGqlBaseOptions): Observable<IApiCertificationAgencyCommentConnection> {
    return this.gqlCertificationAgencyCommentService.getCertificationAgencyComments(filters, options || new ListPage());
  }

  public add(input: IApiAddCertificationAgencyCommentInput) {
    return this.gqlCertificationAgencyCommentService.addCertificationAgencyComment(input);
  }

}
